const getSubstring = (text, position = 0, separator = '-') => {
  let response = null;

  if (typeof text === 'string')
    response = text.split(separator)[position].trim();

  if (typeof text === 'number') response = text.toString();

  return response;
};

const padStart = (value, length = 0, fillString = '0') =>
  value && value.toString().padStart(length, fillString);

const UNITS = [
  '',
  'un ',
  'dos ',
  'tres ',
  'cuatro ',
  'cinco ',
  'seis ',
  'siete ',
  'ocho ',
  'nueve ',
];

const TENS = [
  'diez ',
  'once ',
  'doce ',
  'trece ',
  'catorce ',
  'quince ',
  'dieciseis ',
  'diecisiete ',
  'dieciocho ',
  'diecinueve ',
  'veinte ',
  'treinta ',
  'cuarenta ',
  'cincuenta ',
  'sesenta ',
  'setenta ',
  'ochenta ',
  'noventa ',
];

const HUNDREDS = [
  '',
  'ciento ',
  'doscientos ',
  'trecientos ',
  'cuatrocientos ',
  'quinientos ',
  'seiscientos ',
  'setecientos ',
  'ochocientos ',
  'novecientos ',
];

const getUnits = (numbers) => {
  const num = String(numbers).slice(-1);
  return UNITS[parseInt(num, 10)];
};

const getTents = (num) => {
  const s = String(num);
  const n = parseInt(s, 10);

  if (n < 10) return getUnits(s);

  if (n > 19) {
    const u = getUnits(s);
    if (u === '') {
      return TENS[parseInt(s.substring(0, 1), 10) + 8];
    }

    if (n === 20) return 'veinte ';

    if (n > 20 && n < 30) {
      return TENS[parseInt(s.substring(0, 1), 10) + 8] + u;
    }

    return `${TENS[parseInt(s.substring(0, 1), 10) + 8]}y ${u}`;
  }

  return TENS[n - 10];
};

const getHundreds = (num) => {
  const s = String(num);
  const n = parseInt(s, 10);

  if (n > 99) {
    if (n === 100) return ' cien ';
    return HUNDREDS[parseInt(s.substring(0, 1), 10)] + getTents(s.substring(1));
  }

  return getTents(String(n));
};

const getThousands = (number) => {
  const s = String(number);
  const c = s.substring(s.length - 3);
  const m = s.substring(0, s.length - 3);
  const n = parseInt(m || '0', 10);

  if (n > 0) {
    const prefix = getHundreds(m);
    return `${prefix}mil ${getHundreds(c)}`;
  }
  return `${getHundreds(c)}`;
};

const getMillions = (number) => {
  const s = String(number);
  const thousands = s.substring(s.length - 6);
  const million = s.substring(0, s.length - 6);

  let n = '';
  if (million.length > 1) {
    n = `${getHundreds(million)}millones `;
  } else {
    n = `${getUnits(million)}millon `;
  }
  return n + getThousands(thousands);
};

const convertNumberToText = (number, upperCase = false) => {
  let literal = '';
  let str = String(number).replace('.', ',');

  if (!str.includes(',')) str += ',00';

  const re = /^\d{1,9},\d{1,2}$/;
  if (!re.test(str)) return null;

  const [intPart, decPartRaw] = str.split(',');
  const decPart = `${decPartRaw}/100 Soles.`;

  const intVal = parseInt(intPart, 10);

  if (intVal === 0) literal = 'cero ';
  else if (intVal > 999999) literal = getMillions(intPart);
  else if (intVal > 999) literal = getThousands(intPart);
  else if (intVal > 99) literal = getHundreds(intPart);
  else if (intVal > 9) literal = getTents(intPart);
  else literal = getUnits(intPart);

  const out = literal + decPart;
  return upperCase ? out.toUpperCase() : out;
};

export { getSubstring, padStart, convertNumberToText };
